import React, { useState, useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import VideoPlayer from '../../atoms/VideoPlayer';

import './style.scss';

const PAGE_SIZE = 8;

const ListVideos = ({ videoLists }) => {
  const [currentPage, updateCurrentPage] = useState(0);
  const [currentVideo, updateCurrentVideo] = useState('');
  const handlePageClick = ({ selected }) => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    updateCurrentPage(selected);
  };

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);
    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, []);

  const escFunction = (event) => {
    if (event.keyCode === 27) {
      updateCurrentVideo('');
    }
  };

  const receivedData = () => {
    return (
      <div className='video_grids'>
        <div className='row'>
          {videoLists.slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE).map((item) => {
            let {
              lessonDesc = '',
              lessonId = '',
              lessonImage = '',
              lessonVideo = '',
              topicName = '',
              topicId = '',
            } = item;
            return (
              <div
                className='col4'
                id={lessonId}
                key={lessonId}
                item
                onClick={() => updateCurrentVideo(lessonVideo)}
              >
                <div className='video_summary'>
                  <figure>
                    <img
                      src={lessonImage}
                      alt='Trulli'
                      width='100'
                      height='100'
                    />
                    <a className='play-btn'>
                      <img
                        src={require('../../../Assets/Images/Icons/play_icon.png')}
                        alt=''
                      />
                    </a>
                  </figure>
                  <h6 style={{}}>{topicName}</h6>
                  <p style={{}}>{lessonDesc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div>
      {!!currentVideo && (
        <VideoPlayer
          open={!!currentVideo}
          url={currentVideo}
          toggleModal={() => updateCurrentVideo('')}
        />
      )}
      {receivedData()}
      {videoLists.length > PAGE_SIZE && (
        <ReactPaginate
          nextClassName={'next-button'}
          previousClassName={'next-button'}
          pageCount={videoLists.length / PAGE_SIZE}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
        />
      )}
    </div>
  );
};

export default ListVideos;
